export default (urlPath, language, query, params) => {
  return {
    metaData: null,
  };
};
